<ul class="nav nav-tabs justify-content-start">
    <li *ngIf="hasRole(TipoUsuario.SUPERVISOR, TipoUsuario.OPERADOR_3, TipoUsuario.OPERADORDIRECTO,TipoUsuario.TUTOR, TipoUsuario.SOPORTE)"
        class="nav-item"><a class="nav-link" routerLink="alijesSaldos" routerLinkActive="active"><b>Saldos alije</b></a>
    </li>
    <li *ngIf="hasRole(TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.COMERCIAL, TipoUsuario.TUTOR, TipoUsuario.RESPRODUCTO, TipoUsuario.COMERCIAL_AV, TipoUsuario.COMERCIAL_LN, TipoUsuario.SOPORTE, TipoUsuario.APROBADORBYR)"
        class="nav-item"><a class="nav-link" routerLink="alijesReportes" routerLinkActive="active"><b>Reportes</b></a>
    </li>    
</ul>

<router-outlet></router-outlet>